"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.user = exports.initialUserState = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxAct = require("redux-act");

var _timezones = require("../timezones/timezones.constants");

var actions = _interopRequireWildcard(require("./user.actions"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var initialUserState = {
  isLoading: false,
  id: 0,
  firstName: '',
  lastName: '',
  organisation: {
    id: 0,
    name: '',
    usingDKIM: false,
    canUseChromeExtension: false
  },
  organisationUrlPrefix: '',
  orgId: 0,
  orgName: '',
  defaultTeam: {
    id: 0,
    name: ''
  },
  avatar: '',
  countryId: null,
  company: '',
  email: '',
  canManageTeams: [],
  timezone: _timezones.DEFAULT_TIMEZONE_NAME,
  joinedAt: '',
  firstAccess: false,
  error: null
};
exports.initialUserState = initialUserState;
var user = (0, _reduxAct.createReducer)({}, initialUserState).on(actions.loadUserRequest, function (state) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: true
  });
}).on(actions.loadUserSuccess, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    id: payload.id,
    firstName: payload.first_name,
    lastName: payload.last_name,
    organisation: payload.organisation,
    organisationUrlPrefix: payload.organisation_url_prefix,
    orgId: payload.organisation.id,
    orgName: payload.organisation.name,
    defaultTeam: payload.default_team,
    avatar: payload.avatar,
    countryId: payload.country_id,
    company: payload.company,
    email: payload.email,
    canManageTeams: payload.can_manage_teams,
    timezone: payload.timezone || state.timezone,
    joinedAt: payload.joinedAt,
    firstAccess: payload.first_access
  });
}).on(actions.loadUserFail, function (state, payload) {
  return _objectSpread(_objectSpread({}, state), {}, {
    isLoading: false,
    error: payload
  });
});
exports.user = user;